#import "./LightBarMitzvahDetails.graphql"
query MyLightBarMitzvotQuery {
  myBarMitzvot {
    ...lightBarMitzvahDetails
  }
}
